import { FunctionalComponent, h } from 'preact';

import { IconTemplatePropsInterface } from 'common/module/icon/template-props.interface';

/**
 * https://www.figma.com/file/BVGglAIgmnat5ZIwihRY9H/PF_Icon-Library?node-id=0%3A1526
 */
export const IconGoogleFilledTemplate: FunctionalComponent<IconTemplatePropsInterface> = (props) => (
  <svg viewBox='0 0 24 24' className={props.class}>
    <use xlinkHref='#svg-google-filled' />
  </svg>
);
